<template>
  <div class="userInfo">
    <nav-bar></nav-bar>
    <img src="@/assets/bannerTop_new.png" alt="" class="backImg">
    <user-detail :userData="userData"/>

    <user-article/>
    <van-cell-group>
      <van-cell title="充值中心" is-link to="/user/pay" icon="debit-pay"/>
      <van-cell title="升级vip" is-link to="/user/upgrade" icon="after-sale"/>
      <van-cell title="充值记录" is-link to="index" icon="orders-o"/>
      <van-cell title="浏览记录" is-link to="index" icon="todo-list-o"/>
      <van-cell title="我的收藏" is-link to="index" icon="like-o" />
      <van-cell title="我的购买" is-link to="index" icon="balance-pay" />
      <van-cell title="修改密码" is-link to="index" icon="edit" />
      <van-cell title="登出" is-link @click="logOut" icon="delete-o" />
    </van-cell-group>
  </div>
</template>

<script>
import NavBar from "@/components/common/NavBar";
import userDetail from "@/components/user/userDetail";
import userArticle from "@/components/user/userArticle";

export default {
  name: "userPage",
  data() {
    return {
      userData: null,
    };
  },
  created() {
    this.userData = this.$store.getters.getUser
  },
  components: {
    NavBar,
    userDetail,
    userArticle,
  },
  methods:{
    async logOut(){
      await this.$store.dispatch('logout')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.userInfo {
  .backImg {
    height: calc(91px + 13.056vw);
    width: 100%;
    object-fit: cover;
  }
}

</style>
